import React, { type FC } from 'react';

import { skeleton } from './styles.css';

interface TextSkeletonProps {
  numberOfCharacters: number;
  height?: number;
}

export const TextSkeleton: FC<TextSkeletonProps> = ({
  numberOfCharacters = 10,
  height,
}) => (
  <div className={skeleton} style={{ height: height ?? 'auto' }}>
    {Array(numberOfCharacters + 1).join('_')}
  </div>
);
